import { DialogTitle } from "@headlessui/react";

export const ModalHeader = ({ title }: { title: string }) => {
  return (
    <DialogTitle as="h3" className="text-xl font-medium">
      {title}
    </DialogTitle>
  );
};
